import { defineComponent as _defineComponent } from 'vue'
import ConsentToggleButton from '@/components/consent/ConsentToggleButton.vue';
import { OnboardingStatus } from '@/enums/onboarding-status';
import { useI18n } from '@/helpers/composables/useI18n';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { StaticPage, fetchStaticPages } from '@/helpers/static-page-helper';
import { computed, onMounted, onServerPrefetch, ref } from 'vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooterEuropeanBanner',
  setup(__props) {

const { locale, webLocale } = useLanguageStore();
const { onboardingStatus } = useUserStore();
const router = useRouter();
const { t } = useI18n();

const items = ref([] as StaticPage[]);
const currentYear = new Date().getFullYear();

const assetsDir = computed(() => `/${ASSETS_DIR}`);
const talentPage = computed(() => items.value.find(({ technical_name }) => technical_name === 'STATIC_TALENT'));
const blackFooter = computed(() => onboardingStatus.value === OnboardingStatus.GLOBAL);

onServerPrefetch(async () => {
	await fetchItems();
});

onMounted(async () => {
	await fetchItems();
});

async function fetchItems() {
	items.value = await fetchStaticPages(locale.value);
}

function go(page: string) {
	const path = items.value.find(item => item.technical_name === page)?.full_path;
	if (path) {
		router.push({ path });
	}
}

function goToPrivacyPolicyPage() {
	router.push({ path: `${webLocale.value}/privacy-policy` });
}

return { __sfc: true,locale, webLocale, onboardingStatus, router, t, items, currentYear, assetsDir, talentPage, blackFooter, fetchItems, go, goToPrivacyPolicyPage, ConsentToggleButton }
}

})